
import Vue from 'vue';
import { message } from 'ant-design-vue';
import WorkFileUploader from './WorkFileUploader.vue';

interface AiSupplementValue {
  isAi: string;
  tools: string;
  cover: string;
  overUrl: string;
  contents: string;
}

interface UploaderRef extends Vue {
  hasFiles(): boolean;
  uploadToOss(): Promise<string[]>;
  clear(): void;
  setInitialFile(url: string): void;
}

const createDefaultValue = (): AiSupplementValue => ({
  isAi: '1',
  tools: '',
  cover: '',
  overUrl: '',
  contents: '',
});

export default Vue.extend({
  name: 'AiSupplementFields',
  components: {
    WorkFileUploader,
  },
  props: {
    value: {
      type: Object,
      default: createDefaultValue,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentValue(): AiSupplementValue {
      const source = (this.value || {}) as any;
      return {
        isAi: String(source.isAi === undefined ? '1' : source.isAi),
        tools: source.tools || '',
        cover: source.cover || '',
        overUrl: source.overUrl || source.over_url || '',
        contents: source.contents || '',
      };
    },
  },
  methods: {
    getUploader(): UploaderRef | null {
      const ref = this.$refs.coverUploader as UploaderRef | UploaderRef[];
      return Array.isArray(ref) ? ref[0] : ref || null;
    },
    emitValue(patch: Partial<AiSupplementValue>) {
      this.$emit('input', {
        ...this.currentValue,
        ...patch,
      });
    },
    getInputValue(event: Event): string {
      return String((event.target as HTMLInputElement).value || '');
    },
    updateField(key: keyof AiSupplementValue, event: Event) {
      this.emitValue({ [key]: this.getInputValue(event) } as Partial<
        AiSupplementValue
      >);
    },
    handleAiChange(isAi: string) {
      if (isAi === '0') {
        const uploader = this.getUploader();
        if (uploader) {
          uploader.clear();
        }
        this.$emit('validating-change', false);
        this.emitValue({
          isAi,
          tools: '',
          cover: '',
          overUrl: '',
          contents: '',
        });
        return;
      }

      this.emitValue({ isAi });
    },
    isValidLink(link: string): boolean {
      return /^https?:\/\/.+/i.test(link);
    },
    validate(): boolean {
      if (this.currentValue.isAi !== '1') {
        return true;
      }

      if (
        this.currentValue.overUrl &&
        !this.isValidLink(this.currentValue.overUrl)
      ) {
        message.error('请输入正确的生成结果链接');
        return false;
      }

      return true;
    },
    setInitialCover(url: string) {
      this.emitValue({ cover: url || '' });
      if (this.currentValue.isAi !== '1') {
        return;
      }

      this.$nextTick(() => {
        const uploader = this.getUploader();
        if (uploader) {
          uploader.setInitialFile(url || '');
        }
      });
    },
    async uploadCoverToOss(): Promise<string> {
      if (this.currentValue.isAi !== '1') {
        return '';
      }

      const uploader = this.getUploader();
      const urls = uploader ? await uploader.uploadToOss() : [];
      const coverUrl = urls[0] || this.currentValue.cover || '';
      this.emitValue({ cover: coverUrl });
      return coverUrl;
    },
    clear() {
      const uploader = this.getUploader();
      if (uploader) {
        uploader.clear();
      }
      this.$emit('validating-change', false);
      this.$emit('input', createDefaultValue());
    },
  },
});
